module.exports = __webpack_public_path__ + "img/feats-6.539f458a.jpg";